import { Controller } from "@hotwired/stimulus"

// Adds and removes rows in the onboarding page plan. Rows are submitted in
// page order, so a new row only needs a key no other row uses; keys must be
// numeric for Rails to permit them.
export default class extends Controller {
  static targets = ["list", "template"]

  add() {
    const key = Date.now()
    this.listTarget.insertAdjacentHTML("beforeend", this.templateTarget.innerHTML.replaceAll("NEW_PAGE", key))
    this.listTarget.lastElementChild.querySelector("input[type=text]")?.focus()
  }

  remove(event) {
    event.currentTarget.closest("[data-page-row]").remove()
  }
}
